module.exports = __webpack_public_path__ + "images/help/video-invite-small@2x-2511d29c51b99089efbcd0120bc086ea.png";